import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useAuth } from '../../services/auth/AuthContext';
import { Avatar, Box, Divider, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LogoutMenu = ({ user }) => {
  const { logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const { t } = useTranslation();

  const first_name = user?.user_profile?.first_name || '';
  const handleLogout = () => {
    logout();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box display='flex' flexDirection='row'>
      <IconButton
        onClick={handleMenuOpen}
        sx={{
          borderRadius: '50%',
        }}
      >
        <Avatar
          sx={({ palette }) => ({
            border: `2px solid ${palette.primary.dark}`,
            background: palette.primary.main,
          })}
        >
          {first_name?.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {first_name && (
          <MenuItem disabled>
            {t('welcome')}, {first_name}
          </MenuItem>
        )}

        {first_name && (
          <Divider sx={{ mx: 1 }} />
        )}

        <MenuItem onClick={handleLogout}>
          {t('logout')}
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LogoutMenu;
